export * from "./amplifyAuth";
export { default as setUpAmplifyConfig } from "./setUpAmplify";
